package net.sergeych.ugdx.shared

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import net.sergeych.crypto2.UniversalPublicKey

/*
 * Inner structures that are used in API data exchange with ugdx server:
 */

@Serializable
data class AccountInfo(
    /**
     * Unique user id in the system. This is the only way to compare users as login names, public keys can be changed
     * and [createdAt] is not unique.
     */
    val id: Long,
    /**
     * Current login name. Could be used to connect between users. Could also be hidden, in which case will
     * contain empty or even a random string.
     */
    val loginName: String,
    val isAdmin: Boolean,
    /**
     * Blocked by administration. Account functionality is limited.
     */
    val isBlocked: Boolean,
    /**
     * Permission to use exchange service. Service policies control it
     */
    var canUseExchange: Boolean,
    /**
     * Test users are faster to register, but (1) can be deleted by anybody (test scripts) and are restricted in
     * operations with valuables.
     */
    val isTest: Boolean,
    /**
     * Invite bonus normally is set when an account is created with a valid invite code, reduces commission costs
     * for operations. This binus could also be awarded later, for example, if many users had used this one as
     * inviter.
     */
    val hasInviteBonus: Boolean,

    /**
     * The current public key identity.
     */
    val publicKeyId: UniversalPublicKey,
    /**
     * Dd not rely on it. Account creation time.
     */
    val createdAt: Instant,

    val partyId: String
)

